module.exports = __webpack_public_path__ + "img/BG831558413.f293ba8e.png";